// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-button {
  --background: transparent;
  color: var(--ion-color-primary);
  --border-color: var(--ion-color-primary);
  --border-width: 2px;
  --border-style: solid;
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 16px !important;
  --border-bottom: none;
  border: none;
}

.forgot-password {
  margin: 20px 0;
  cursor: pointer;
}
.forgot-password h3 {
  color: var(--ion-color-primary) !important;
  font-size: 14px;
  font-weight: bold;
}

.wrapper {
  padding: 25px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
.button-wrapper ion-button.google {
  --background: #D0463B;
}
.button-wrapper ion-button.facebook {
  --background: #3B5997;
}
.button-wrapper ion-button.apple {
  --background: black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-in/sign-in.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,+BAAA;EACA,wCAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AACA;EACE,8BAAA;EACA,gCAAA;EACA,qBAAA;EACA,YAAA;AAEF;;AACA;EACE,cAAA;EACA,eAAA;AAEF;AAAE;EACE,0CAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AACA;EACE,aAAA;AAEF;;AACA;EACC,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAED;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AAEA;EACE,oCAAA;EACA,iCAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAEF;AADE;EACE,WAAA;EACA,gBAAA;AAGJ;AADE;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAEJ;AADI;EACI,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAGR;AADI;EACI,kBAAA;EACA,SAAA;AAGR;AADI;EACI,qBAAA;AAGR;AADI;EACI,qBAAA;AAGR;AADI;EACI,mBAAA;AAGR","sourcesContent":[".sign-up-button {\n  --background: transparent;\n  color: var(--ion-color-primary);\n  --border-color: var(--ion-color-primary);\n  --border-width: 2px;\n  --border-style: solid;\n}\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\nion-item {\n  --border-width: 1px !important;\n  --border-radius: 16px !important;\n  --border-bottom: none;\n  border: none;\n}\n\n.forgot-password {\n  margin: 20px 0;\n  cursor: pointer;\n\n  h3 {\n    color: var(--ion-color-primary) !important;\n    font-size: 14px;\n    font-weight: bold;\n  }\n}\n.wrapper{\n  padding: 25px;\n}\n\n.stacked {\n\tposition: static;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 2;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\n\nion-label  {\n  font-family: AppFontBold, sans-serif;\n  color: var(--ion-color-secondary);\n}\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  ion-button {\n    width: 100%;\n    margin: 10px 0px\n  }\n  ion-button {\n    width: 100%;\n    // margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    p {\n        margin-top: 5px;\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        width: 75%;\n    }\n    ion-icon {\n        margin-right: 10px;\n        zoom: 0.9;\n    }\n    &.google {\n        --background: #D0463B;\n    }\n    &.facebook {\n        --background: #3B5997;\n    }\n    &.apple {\n        --background: black;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
